import yup from '../yup';

export const noticeSchema = yup.object().shape({
  notice: yup.string()
    .nullable()
    .required('お知らせを入力してください。')
    .max(1000, '入力文字数は1000文字以下にしてください。')
    .label('お知らせ'),
});
